import styled from 'styled-components';

export const ListItem = styled.li`
  ${({ theme }) => theme.fontSize.M16};
  display: flex;
  flex: 1 0 auto;

  &:before {
    flex: 0 0 ${({ theme }) => theme.spacing.M24};
    content: '•';
    text-align: center;
  }
`;
